<template>
  <div class="flex text-md items-center group"
       :class="deal.exclude ? 'text-text-muted':'text-text'">
    <div>
      <ToggleWText :checked="!deal.exclude"
                   :text-on="$t('consider')"
                   :text-off="$t('ignore')"
                   @change="$emit('toggle')"/>
    </div>
    <div>{{ deal.date_time }}</div>
    <div>{{ deal.type_name }}</div>
    <div>{{ deal.currency }}</div>
    <div class="text-right">{{ dealSum(deal) }}</div>
    <div>...</div>
  </div>
</template>

<script>
import AssetIcon from "@/components/cabinet/Investments/InvestmentAssets/InvestmentAssetItem/AssetIcon";
import IconTrash from "@/components/icons/IconTrash";
import BaseButton from "@/components/UI/BaseButton";
import {mapGetters} from "vuex";
import ToggleWText from "@/components/UI/ToggleWText";

export default {
  name: "DuplicateListItem",
  components: {ToggleWText, BaseButton, IconTrash, AssetIcon},
  props: {
    deal: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue', 'getCurrencyByCode']),
  },
  methods: {
    displayedText(deal) {
      let {date_time, ticker, type_name, amount, sum, currency} = deal,
          currencyObj = this.getCurrencyByCode(currency),
          displaySum = this.displayCurrencyValue(sum, currencyObj);
      return `${date_time} ${type_name} <span class="font-bold">${ticker}</span> ${this.$t('worth')} ${displaySum}`;
    },
    dealSum(deal) {
      let {sum, currency} = deal,
          currencyObj = this.getCurrencyByCode(currency)
      return this.displayCurrencyValue(sum, currencyObj);
    }
  },
  i18n: {
    messages: {
      en: {
        worth: 'worth',
        consider: 'Submit',
        ignore: 'Skip',
      },
      ru: {
        worth: 'на сумму',
        consider: 'Внести',
        ignore: 'Пропустить',
      }
    }
  }
}
</script>